import React, { useEffect, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TxnTypeModal = ({ value, close, handle_change }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="absolute bottom-[0px] bg-white rounded-xl shadow-3xl max-w-md overflow-x-hidden rounded-bl-none rounded-br-none w-full">
        <div
          className="flex justify-end gap-2 items-center p-4"
          onClick={close}
        >
          <img src={ImageLinks.close} className="w-[14px] h-[14px]" />
        </div>
        <p className="px-6 font-custom text-sm font-semibold text-dark_black">
          {t("transaction_type")}
        </p>
        <div className="px-6 py-4 pb-14 text-center flex gap-8 flex-col h-[250px]">
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => {
              const selected_value = { title: "All", value: "all" };
              handle_change(selected_value);
              close();
            }}
          >
            <p className="font-custom text-sm font-semibold text-dark_black">
              {t("all")}
            </p>

            <input
              id="default-radio-1"
              type="radio"
              value={JSON.stringify({ title: "All", value: "all" })}
              name="default-radio"
              checked={value?.value === "all"}
              readOnly
              className="w-4 h-4 accent-secondary pointer-events-none"
            />
          </div>
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => {
              const selected_value = { title: "Credit", value: "credit" };
              handle_change(selected_value);
              close();
            }}
          >
            <p className="font-custom text-sm font-semibold text-dark_black">
              {t("credit")}
            </p>

            <input
              id="default-radio-1"
              type="radio"
              value={JSON.stringify({ title: "Credit", value: "credit" })}
              name="default-radio"
              checked={value?.value === "credit"}
              readOnly
              className="w-4 h-4 accent-secondary pointer-events-none"
            />
          </div>
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => {
              const selected_value = { title: "Debit", value: "debit" };
              handle_change(selected_value);
              close();
            }}
          >
            <p className="font-custom text-sm font-semibold text-dark_black">
              {t("debit")}
            </p>

            <input
              id="default-radio-1"
              type="radio"
              value={JSON.stringify({ title: "Debit", value: "debit" })}
              name="default-radio"
              checked={value?.value === "debit"}
              readOnly
              className="w-4 h-4 accent-secondary pointer-events-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TxnTypeModal;
